var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewssmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1220,
    height: 620,
    viewBox: "0 0 1220 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 20.6812 0 16.0218 1.52241 12.3463C3.55229 7.44577 7.44577 3.55229 12.3463 1.52241C16.0218 0 20.6812 0 30 0H1190C1199.32 0 1203.98 0 1207.65 1.52241C1212.55 3.55229 1216.45 7.44577 1218.48 12.3463C1220 16.0218 1220 20.6812 1220 30V590C1220 599.319 1220 603.978 1218.48 607.654C1216.45 612.554 1212.55 616.448 1207.65 618.478C1203.98 620 1199.32 620 1190 620H30C20.6812 620 16.0218 620 12.3463 618.478C7.44577 616.448 3.55229 612.554 1.52241 607.654C0 603.978 0 599.319 0 590V30Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewssmall);
export default __webpack_public_path__ + "static/media/newssmall.311dde7d167f7a30174c14516a99ec7e.svg";
export { ForwardRef as ReactComponent };